var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrandmaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 902,
    height: 819,
    viewBox: "0 0 902 819",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.7 648.9C173.4 612 143.3 552.8 143.3 490.4V489L4.69995 409L143.3 329V228L214.6 175.8L197.3 16.6999L343.8 81.2999L450.8 2.8999L557.8 81.2999L704.3 16.6999L687 175.9L758.3 228.1V329.1L897 409L758.3 489.1V490.5C758.3 552.9 728.2 612.1 677.9 649L450.8 815.2L223.7 648.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2 228.1L450.8 409V2.8999L143.2 228.1Z",
    fill: "#85B0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.3 82L350.2 225.5L450.8 152.5V6.80005L339.3 82Z",
    fill: "#9EE0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 6.80005V409L755 230.2L450.8 6.80005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6 228.9L147.3 522.8L164.1 576.3L450.8 409L259 296.2L144.6 228.9Z",
    fill: "#283E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.6 576.5L450.8 409V811.4L704.7 621.8L735.6 576.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 818.1V409L164.1 576.3L198.7 625.5L450.8 818.1Z",
    fill: "#440A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.4 517.3L755 230.2L450.8 409L739.8 579L755.4 517.3Z",
    fill: "#5E1016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.1 580.5C285.1 543.2 254.7 483.2 254.7 420V293.7L450.8 150.1L646.9 293.7V420C646.9 483.2 616.5 543.2 565.5 580.5L450.8 664.5L336.1 580.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 318.6L450.8 409V206L297 318.6Z",
    fill: "#FCA82D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 206V409L604.7 318.6L450.8 206Z",
    fill: "#B20B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 318.6L304.2 455.3L320.9 485.4L450.8 409L297 318.6Z",
    fill: "#E51D13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.4 487.6L450.8 409V612.1L524.1 558.5L584.4 487.6Z",
    fill: "#751231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 612.1V409L319.5 486.3L361.9 547L450.8 612.1Z",
    fill: "#B20B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.6 452.8L604.7 318.6L450.8 409L582.1 486.3L598.6 452.8Z",
    fill: "#E51D13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3 363.4V400.6C373.3 434.6 389.5 466.5 416.9 486.6L450.9 511.5L484.9 486.6C512.3 466.5 528.5 434.6 528.5 400.6V363.4L450.9 306.6L373.3 363.4Z",
    fill: "#F9213C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 218.3L594.6 323.6V420C594.6 442.9 589.1 465.9 578.7 486.3C568.3 506.8 553 524.7 534.5 538.3L450.7 599.6L367 538.4C348.5 524.8 333.2 506.9 322.8 486.4C312.5 465.9 307 443 307 420.1V323.7L450.8 218.3ZM450.8 206L297 318.6V420.1C297 470 320.8 517 361.1 546.5L450.8 612.2L540.5 546.5C580.8 517 604.6 470 604.6 420.1V318.6L450.8 206Z",
    fill: "#E51D13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 82L549.6 228.1L687.2 173.5L704.6 16.3L558 82Z",
    fill: "#440A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 82L549.6 228.1L623.8 126.7L704.6 16.3L558 82Z",
    fill: "#9EE0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 79.6L352.1 228.1L214.3 175.6L197 16.3L340.5 79.6Z",
    fill: "#192438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 81.3L352.1 228.1L277.8 126.7L197.4 16.8L343.5 81.3Z",
    fill: "#38557F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.6 487.8L644.3 415.1L645.9 402L756.6 330.5L892.8 409.1L756.6 487.8Z",
    fill: "#283E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.9 488L644.3 415.1L645.7 409H760.7H892.8L756.9 488Z",
    fill: "#440A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 486L257.5 415L256.7 402.6L141 329.9L5.30005 409L141 486Z",
    fill: "#85B0ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8 487.6L259 414L256 409H141H5.30005L143.8 487.6Z",
    fill: "#440A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 12.4L552.2 86.6L556.9 90L562.2 87.7L695.3 29L679.6 173.7L679 179.4L683.7 182.8L750.7 231.9V327.6V333.4L755.7 336.3L881.7 409.1L755.7 481.9L750.7 484.8V490.6C750.7 520.1 743.6 549.7 730.3 576C716.9 602.3 697.3 625.5 673.5 642.9L450.8 805.7L228.3 642.8C204.5 625.4 184.8 602.2 171.5 575.9C158.1 549.5 151 520 151 490.5V484.7L146 481.8L20 409L146 336.2L151 333.3V327.5V231.8L218 182.7L222.7 179.3L222.1 173.6L206.3 29L339.4 87.7L344.7 90L349.4 86.6L450.8 12.4ZM450.8 0L343.5 78.6L194.5 12.9L212.1 174.8L141 226.8V327.6L0 409L141 490.4C141 553.8 171.2 613.3 222.4 650.8L450.9 818.1L679.4 650.8C730.5 613.4 760.8 553.8 760.8 490.4L901.8 409L760.8 327.6V226.8L689.7 174.7L707.3 12.8L558.3 78.5L450.8 0Z",
    fill: "#465182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 12.4L552.2 86.6L556.9 90L562.2 87.7L695.3 29L679.6 173.7L679 179.4L683.7 182.8L750.7 231.9V327.6V333.4L755.7 336.3L881.7 409.1L755.7 481.9L750.7 484.8V490.6C750.7 520.1 743.6 549.7 730.3 576C716.9 602.3 697.3 625.5 673.5 642.9L450.8 805.7L228.3 642.8C204.5 625.4 184.8 602.2 171.5 575.9C158.1 549.5 151 520 151 490.5V484.7L146 481.8L20 409L146 336.2L151 333.3V327.5V231.8L218 182.7L222.7 179.3L222.1 173.6L206.3 29L339.4 87.7L344.7 90L349.4 86.6L450.8 12.4ZM450.8 0L343.5 78.6L194.5 12.9L212.1 174.8L141 226.8V327.6L0 409L141 490.4C141 553.8 171.2 613.3 222.4 650.8L450.9 818.1L679.4 650.8C730.5 613.4 760.8 553.8 760.8 490.4L901.8 409L760.8 327.6V226.8L689.7 174.7L707.3 12.8L558.3 78.5L450.8 0Z",
    fill: "#465182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.3 754.8L228.3 642.8C213.7 632.1 200.7 619.3 189.8 605L182.3 611.7C193.6 626.4 207.1 639.7 222.4 650.9L364.9 755.2C370.3 755.1 375.8 754.9 381.3 754.8Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7001 367.6L146 336.3L151 333.4V327.6V303.5L141 305.6V327.6L86.6001 359L91.7001 367.6Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.5 453L755.7 481.8L750.7 484.7V490.5C750.7 504.5 749.1 518.5 746 532.2L756.7 530.4C759.4 517.4 760.8 504 760.8 490.5L808.4 463L805.5 453Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 192.4C190.3 194.9 192.6 197.4 194.8 199.8L218 182.8L222.7 179.4L222.1 173.7L218.1 136.5C214.9 137.6 211.6 138.8 208.4 139.9L212.2 174.8L188 192.4Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.8 712.8L497 771.9L505.7 777.9L577.7 725.2C577.7 721.2 577.8 717 577.8 712.8Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.7 231.9V307.1L760.7 305.4V226.8L734.9 207.9L722.8 211.5L750.7 231.9Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9 19.8L472.2 28L552.2 86.6001L556.9 90L562.2 87.7L582.9 78.6L581.9 68.1L558.2 78.6L477.9 19.8Z",
    fill: "#528ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 218.3L594.6 323.6V420C594.6 442.9 589.1 465.9 578.7 486.3C568.3 506.8 553 524.7 534.5 538.3L518.1 550.3L450.7 599.6L367.7 538.8L366.9 538.2C348.4 524.6 333.1 506.7 322.7 486.2C312.5 465.9 307 443 307 420.1V323.7L450.8 218.3ZM450.8 206L297 318.6V420.1C297 470 320.8 517 361.1 546.5L361.9 547.1L450.8 612.2L524.1 558.5L540.5 546.5C580.8 517 604.6 470 604.6 420.1V318.6L450.8 206Z",
    fill: "#E51D13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.8 155.8L642.6 296.2V419.7C642.6 481.5 612.8 540.2 563 576.7L450.8 658.8L338.6 576.7C288.7 540.2 259 481.5 259 419.7V296.2L450.8 155.8ZM450.8 143.4L444.9 147.7L253.1 288.1L249 291.1V296.2V419.7C249 484.7 280.3 546.4 332.7 584.8L444.9 666.9L450.8 671.2L456.7 666.9L568.9 584.8C621.3 546.4 652.6 484.7 652.6 419.7V296.2V291.1L648.5 288.1L456.7 147.7L450.8 143.4Z",
    fill: "#283E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 901.7,
    height: 818.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandmaster);
export default __webpack_public_path__ + "static/media/grandmaster.0f3bc5674e8ec76f17514f197242c4fa.svg";
export { ForwardRef as ReactComponent };